// extracted by mini-css-extract-plugin
export default {"root":"SideFilter_root__IjH9K"};